import { useState } from "react"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Button } from "@/components/ui/button"

export default function ResetPasswordForm({ onBack }) {
    const [email, setEmail] = useState("")
    const [role, setRole] = useState("candidate")
    const [status, setStatus] = useState(null)
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        try {
            const response = await fetch(`/api/v1/${role}s/password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({ [role]: { email } }),
            })

            if (response.ok) {
                setStatus("success")
            } else {
                setStatus("error")
            }
        } catch (err) {
            console.error(err)
            setStatus("error")
        } finally {
            setLoading(false)
        }
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <Label htmlFor="role">I am...</Label>
                <select
                    id="role"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
                >
                    <option value="candidate">Looking for work</option>
                    <option value="client">Looking to hire</option>
                </select>
            </div>

            <div>
                <Label htmlFor="email">Email</Label>
                <Input
                    id="email"
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>

            {status === "success" && (
                <p className="text-green-600 text-sm">Check your inbox for reset instructions.</p>
            )}
            {status === "error" && (
                <p className="text-red-600 text-sm">Something went wrong. Please try again.</p>
            )}

            <div className="flex justify-between items-center">
                <Button type="button" variant="outline" onClick={onBack}>
                    Back
                </Button>
                <Button type="submit" className="bg-brand-500" disabled={loading}>
                    {loading ? "Sending..." : "Send reset link"}
                </Button>
            </div>
        </form>
    )
}
